import { render, staticRenderFns } from "./Add-credits.vue?vue&type=template&id=13de0b6a&scoped=true&lang=html"
import script from "./Add-credits.vue?vue&type=script&lang=js"
export * from "./Add-credits.vue?vue&type=script&lang=js"
import style0 from "./Add-credits.vue?vue&type=style&index=0&id=13de0b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de0b6a",
  null
  
)

export default component.exports